import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import TemplateLayout from '../../Commons/TemplateLayout';
import { useContext, useEffect, useState } from 'react';
import {
  getProjectTemplateById,
  updateProjectTemplate,
} from '../../../../../../services/api/projectTemplates';
import { MainContext } from '../../../../../../context/MainContext';
import { useIntl } from 'react-intl';
import SuccessPage from '../../Commons/TemplateLayout/components/SuccessPage';
import DeliveryFormFields from '../Commons/LaboratoryFormFields';
import {
  getLaboratory,
  updateLaboratory,
} from '../../../../../../services/api/laboratory';

const UpdateLaboratoryTemplate = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { project } = useOutletContext();
  const { templateId, id } = useParams();
  const { setError, setLoading } = useContext(MainContext);
  const [success, setSuccess] = useState(false);
  const [template, setTemplate] = useState();
  const [regions, setRegions] = useState([]);
  const [initialData, setInitialData] = useState();

  const updateLaboratoryTemplate = async (regions, formState, fileName) => {
    try {
      setLoading(true);
      const regionIndex = regions.findIndex((reg) => reg.data === 'provider');
      const region = regions[regionIndex];
      regions.splice(regionIndex, 1);

      const laboratory = {
        id: template.labId,
        name: formState.supplier_id,
        phone_number: formState.phone_number,
        email: formState.email,
      };

      await updateLaboratory(laboratory);

      const templateToUpdate = {
        id: templateId,
        name: formState.templateName,
        supplier: formState.supplier_id,
        model: 'laboratory',
        image: fileName.replace('pdf', 'png'),
        labId: template.labId,
        createdAt: template.createdAt,
        searchableRegion: {
          value: '',
          region: region,
        },
        regions: regions,
        pid: parseInt(id, 10),
      };

      const updatedTemplate = await updateProjectTemplate(templateToUpdate);

      if (updatedTemplate.data) {
        setSuccess(true);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function loadTemplate() {
      setLoading(true);
      setLoading(true);
      const loadedTemplate = (await getProjectTemplateById({ id: templateId }))
        .data;
      setTemplate(loadedTemplate);
      const loadedLaboratory = (await getLaboratory(loadedTemplate.labId)).data;
      loadedTemplate.regions.push(loadedTemplate.searchableRegion.region);
      setInitialData({
        templateName: loadedTemplate.name,
        supplier_id: loadedTemplate.supplier,
        phone_number: loadedLaboratory.phone_number,
        email: loadedLaboratory.email,
      });
      setRegions(
        loadedTemplate.regions.map((region, index) => ({
          ...region,
          index,
          isVisible: true,
        })),
      );
      setLoading(false);
    }
    loadTemplate();
  }, [setLoading, templateId]);

  if (success) {
    return (
      <SuccessPage
        title={intl.formatMessage({
          id: 'pages.ocr.templates.delivery.edit.success.title',
        })}
        subtitle={intl.formatMessage({
          id: 'pages.ocr.templates.delivery.edit.success.subtitle',
        })}
        onBackToTemplates={() =>
          navigate(`/app/project/${project.id_project}/quality/ocr/templates`)
        }
      />
    );
  }
  return (
    <TemplateLayout
      topFormFields={<DeliveryFormFields editMode={true} />}
      model="laboratory"
      initialData={initialData}
      regions={regions}
      onFinish={updateLaboratoryTemplate}
      onBack={() =>
        navigate(`/app/project/${project.id_project}/quality/ocr/templates`)
      }
    />
  );
};

export default UpdateLaboratoryTemplate;
